import React from 'react'
import PropTypes from 'prop-types'
import MDReactComponent from 'react-markdown/with-html'

const Markdown = ({text, ...props}) => <MDReactComponent
	escapeHtml={false}
	// tags={{html: 'div'}}
	source={text || ''}
	{...props}/>

Markdown.propTypes = {
	text: PropTypes.string.isRequired,
}

export default Markdown
